import { Component, Inject, OnInit, Optional } from '@angular/core';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { ModalService } from '@app/core/services/modal.service';
import { SrCheckListCrewChangeGet, SrCheckListCrewItem, SrChecklistService } from '@app/services/sr-checklist.service';

@Component({
    selector: 'tt-sr-check-list-crew-change',
    templateUrl: './sr-check-list-crew-change.component.html',
    styleUrls: ['./sr-check-list-crew-change.component.css'],
    standalone: false,
})
export class SrCheckListCrewChangeComponent implements OnInit {
    public page?: SrCheckListCrewChangeGet;
    public crews: SrCheckListCrewItem[] = [];
    public searching = false;
    public saving = false;
    private loadVersion = 0;

    constructor(
        private readonly checklist: SrChecklistService,
        private readonly modal: ModalService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) { this.navigator = useNavigatorFor(navigator, this); }

    public async ngOnInit(): Promise<void> {
        this.page = await this.checklist.getCrewChange({ checklistdata_keyno: String(this.navigator?.params['checklistdata_keyno'] ?? '') });
        await this.loadCrews();
    }

    public async selectMode(value: string): Promise<void> {
        if (!this.page || this.page.bg_srchecklistcrewchange_main === value) return;
        this.page.bg_srchecklistcrewchange_main = value;
        await this.loadCrews();
    }

    public async searchCrews(): Promise<void> {
        if (!this.searching) await this.loadCrews();
    }

    private async loadCrews(): Promise<void> {
        const version = ++this.loadVersion;
        if (!this.page || !this.page.bg_srchecklistcrewchange_main?.trim() || !this.page.signin_dt?.trim() || !this.page.signout_dt?.trim() || this.page.searchtext === undefined || this.page.searchtext === null) {
            this.searching = false;
            return;
        }
        this.searching = true;
        this.crews = [];
        try {
            const crews = await this.checklist.getCrewChanges({ ...this.page });
            if (version === this.loadVersion) this.crews = crews;
        } finally { if (version === this.loadVersion) this.searching = false; }
    }

    public toggleChosen(item: SrCheckListCrewItem): void {
        if (item.item_id === '0' || item.item_id === '-1') return;
        const crew = this.crews.find(crew => crew.item_id === item.item_id);
        if (!crew) return;
        crew.item_is_selected = crew.item_is_selected === '0' ? '1' : '0';
        this.crews = [...this.crews];
    }

    public selectAll(): void {
        this.crews.filter(item => item.item_id !== '0' && item.item_id !== '-1').forEach(item => item.item_is_selected = '1');
        this.crews = [...this.crews];
    }

    public async saveChanges(): Promise<void> {
        if (!this.page || this.saving) return;
        this.saving = true;
        try {
            const records = this.crews.filter(item => item.item_id !== '0' && item.item_id !== '-1' && item.item_is_selected !== '0')
                .map(({ item_id, item_is_selected }) => ({ item_id, item_is_selected }));
            const response = await this.checklist.saveCrewChange({ ...this.page, records });
            if (response.errorcode !== '0') await this.showWarning(response.errormessage);
            else await this.navigator?.back();
        } finally { this.saving = false; }
    }

    private showWarning(message: string): Promise<void> {
        return this.modal.show({ type: 'warning', title: 'Varsel', message, buttons: [{ label: 'OK', cssClass: 'btn-warning', close: true }] });
    }
}
